<template>
    <div class="proposals">
        <Navbar />
        <div class="mt-5 pt-5 kovatek-width">
            <div class="px-0 mx-3 px-sm-2 mx-sm-3 px-md-3 mx-md-3 px-lg-4 mx-lg-4">
                <div class="text-left mt-3 ml-5 mb-4">
                    <a-icon class="mr-1" type="arrow-left" /> <span class="go-back" @click="goBack">Go Back</span>
                </div>
                <div class="row">
                    <div class="col-sm-12 col-md-12 col-lg-8">
                        <div v-if="loading" class="page-loader">
                            <hollow-dots-spinner
                                :animation-duration="1000"
                                :dot-size="15"
                                :dots-num="3"
                                color="#20409a"
                                class="mx-auto"
                            />
                        </div>
                        <div v-else>
                            <a-tabs defaultActiveKey="1">
                                <a-tab-pane tab="Saved Jobs" key="1">
                                    <div class="row">
                                        <a-input
                                            class="mt-4 ml-4 ctrl-search"
                                            size="large"
                                            placeholder="Search"
                                            ref="userNameInput"
                                            autofocus
                                        >
                                            <a-icon slot="prefix" type="search" />
                                            <a-tooltip slot="suffix" title="Extra information">
                                                <a-icon type="info-circle" style="color: rgba(0,0,0,.45)" />
                                            </a-tooltip>
                                        </a-input>
                                        <span class="font-weight-bolder sort-by ml-3">
                                            sort by <span class="latest"> latest </span>
                                        </span>
                                    </div>
                                    <div class="mt-4 mb-5 pt-2">
                                        <div v-if="savedJobs.length" class="p-4 bg-light border shadow-sm add-rounded">
                                            <div :key="work.ID" v-for="(work, i) in savedJobs">
                                                <job :project="work.Project" status="saved" @update="getSavedJobs" />
                                                <hr v-if="i + 1 !== savedJobs.length" />
                                            </div>
                                        </div>
                                        <div class="p-4 bg-light border shadow-sm add-rounded text-center" v-else>
                                            <p>You have not saved any jobs yet</p>
                                        </div>
                                    </div>
                                    <a-pagination
                                        showQuickJumper
                                        v-if="savedJobs.length > 10"
                                        v-model="currentSavedPage"
                                        :total="10"
                                        @change="onChange"
                                    />
                                </a-tab-pane>
                                <a-tab-pane tab="Jobs Applied" key="2" forceRender>
                                    <div class="row">
                                        <a-input
                                            class="mt-4 ml-4 ctrl-search"
                                            size="large"
                                            placeholder="Search"
                                            ref="userNameInput"
                                            autofocus
                                        >
                                            <a-icon slot="prefix" type="search" />
                                            <a-tooltip slot="suffix" title="Extra information">
                                                <a-icon type="info-circle" style="color: rgba(0,0,0,.45)" />
                                            </a-tooltip>
                                        </a-input>
                                        <span class="font-weight-bolder sort-by ml-3">
                                            sort by <span class="latest"> latest </span>
                                        </span>
                                    </div>
                                    <div class="mt-4 mb-5 pt-2">
                                        <div
                                            class="p-4 bg-light border shadow-sm add-rounded"
                                            v-if="appliedJobs.length"
                                        >
                                            <template v-for="(job, i) in appliedJobs">
                                                <job :key="job.ID" status="applied" :project="job.Project" />
                                                <hr :key="job.ID + 'oljie'" v-if="i + 1 !== appliedJobs.length" />
                                            </template>
                                        </div>
                                        <div class="p-4 bg-light border shadow-sm add-rounded text-center" v-else>
                                            <p>You have not saved any jobs yet</p>
                                        </div>
                                    </div>
                                    <a-pagination
                                        showQuickJumper
                                        v-if="appliedJobs.length > 10"
                                        v-model="currentAppliedPage"
                                        :total="10"
                                        @change="onChange"
                                    />
                                </a-tab-pane>
                            </a-tabs>
                        </div>
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-4 px-3 pl-lg-0 pr-lg-3 pt-lg-5 mt-lg-5">
                        <div class="pt-3 mt-2 ml-lg-4" style="position: sticky; top: 75px;">
                            <!-- Notifications -->
                            <Notifications />
                            <!-- Messages -->
                            <!-- <Messages /> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footers />
    </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue';
import Footers from '@/components/Footer.vue';
import Notifications from '@/components/Notifications.vue';
// import Messages from '@/components/Messages.vue';
import Job from '../components/projects/Job.vue';
import { getSavedJobs } from '../utils';
import ProfileMixin from '../mixins/profile';

export default {
    name: 'proposals',
    mixins: [ProfileMixin],
    components: {
        Navbar,
        Footers,
        Notifications,
        // Messages,
        Job,
    },
    data() {
        return {
            loading: true,
            profileData: {},
            workHistory: [],
            currentSavedPage: 1,
            currentAppliedPage: 1,
            appliedJobs: [],
            savedJobs: [],
        };
    },
    methods: {
        onChange() {
            // console.log('Page: ', pageNumber);
        },
        goBack() {
            this.$router.go(-1);
        },
        async getAppliedJobs() {
            // const id = (localStorage.getItem("id"));
            const token = localStorage.getItem('token');

            try {
                const res = await this.$api({
                    url: `/talents/biddings`,
                    method: 'get',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                this.appliedJobs = res.data;
            } catch (err) {
                console.log(err);
            }
        },
        fetchSavedJobs() {
            const data = getSavedJobs();

            console.log({ data });
            this.savedJobs = data;
        },
    },
    async mounted() {
        this.loading = false;
        await Promise.all([this.fetchSavedJobs(), this.getProfile(), this.getAllSettings(), this.getAppliedJobs()]);
    },
};
</script>
<style scoped>
.kova-text {
    color: #20409a;
}
.add-rounded {
    border-radius: 10px;
}
.bg-skills {
    background-color: #dde;
}
.incr-font-1 {
    font-size: 20px;
    font-style: italic;
}
.id {
    width: 100px;
    height: 20px;
    background-color: #7cd192;
    border-radius: 5px;
}
.icon-size {
    font-size: 25px;
}
.icon-size1 {
    font-size: 20px;
}
.btn-kovatek {
    background-color: #20409a;
    font-weight: bold;
    outline: 0;
    border: 0;
    width: 255px;
    height: 45px;
    color: #fff;
    border-radius: 30px;
    transition: 0.25s;
    font-size: 18px;
}
.btn-kovatek:hover {
    background-color: #06216d;
    color: #fff;
}
.bg-kovatek {
    background-color: #20409a;
}
.img-height {
    width: 80px;
    height: 80px;
}
.icon-env {
    font-size: 20px;
}
.ctrl-size {
    font-size: 11px;
}
.intermediate {
    color: rgb(148, 194, 20);
    font-size: 12px;
}
.ctrl-size-1 {
    font-size: 20px;
}
.ctrl-size-2 {
    font-size: 12px;
}
.sort-by {
    position: relative;
    top: 33px;
}
.latest {
    color: #2db7f5;
}
.ctrl-search {
    width: 75%;
}
.bid-color {
    color: #34dd9e;
}
@media screen and (min-width: 992px) and (max-width: 1325px) {
}

@media screen and (min-width: 992px) and (max-width: 1200px) {
    .employer-name {
        font-size: 18px;
    }
    .img-height {
        width: 70px;
        height: 70px;
    }
}

@media screen and (min-width: 768px) and (max-width: 991px) {
}

@media screen and (max-width: 767px) {
    .float-text {
        display: flex;
        justify-content: space-between;
        padding-right: 50px;
    }
    .float-text h6 {
        float: left;
    }
}

@media screen and (max-width: 550px) {
    .ctrl-search {
        width: 55%;
    }
    .img-height {
        width: 75px;
        height: 75px;
    }
}
</style>
